import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { MapPin, Phone, MessageCircle, ExternalLink, Clock } from "lucide-react";

const GMAPS_SHARE = "https://share.google/SSFSfLNLXKEFkAicw";
const DEFAULT_SENDER = {
  name: "Rooftop Print",
  phone: "081314092016",
  address: "Jl. Pagarsih No.122, Cibadak, Kec. Astanaanyar, Kota Bandung, Jawa Barat 40241",
};
const waLink = (phone) => `https://wa.me/${(phone || "").replace(/[^0-9]/g, "").replace(/^0/, "62")}`;

export default function Contact() {
  const [sender, setSender] = useState(DEFAULT_SENDER);
  useEffect(() => { api.get("/settings/sender").then((r) => r.data && setSender(r.data)).catch(() => {}); }, []);
  const mapEmbed = `https://www.google.com/maps?q=${encodeURIComponent(sender.address)}&output=embed`;

  return (
    <div className="App">
      <Navbar />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-10">
          <p className="text-sm text-[#F0005A] uppercase tracking-wider font-semibold mb-1">Hubungi Kami</p>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#00133F]">Kunjungi Toko Rooftop Print</h1>
          <p className="text-slate-600 mt-3 max-w-2xl leading-relaxed">Punya pertanyaan atau ingin konsultasi kebutuhan cetak kustom? Datang langsung ke toko kami atau hubungi lewat WhatsApp.</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          <div className="space-y-4">
            <div className="rounded-2xl border border-slate-200 bg-white p-6" data-testid="contact-info">
              <h2 className="font-heading font-semibold text-lg text-[#00133F] mb-4">{sender.name}</h2>
              <div className="space-y-4 text-sm">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-[#F0005A]/10 flex items-center justify-center shrink-0"><MapPin className="w-5 h-5 text-[#F0005A]" /></div>
                  <div>
                    <p className="font-medium text-[#00133F]">Alamat</p>
                    <p className="text-slate-600 leading-relaxed mt-0.5" data-testid="contact-address">{sender.address}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-[#F0005A]/10 flex items-center justify-center shrink-0"><Phone className="w-5 h-5 text-[#F0005A]" /></div>
                  <div>
                    <p className="font-medium text-[#00133F]">Telepon / WhatsApp</p>
                    <p className="text-slate-600 mt-0.5">{sender.phone}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-[#F0005A]/10 flex items-center justify-center shrink-0"><Clock className="w-5 h-5 text-[#F0005A]" /></div>
                  <div>
                    <p className="font-medium text-[#00133F]">Jam Operasional</p>
                    <p className="text-slate-600 mt-0.5">Senin – Sabtu, 09.00 – 18.00 WIB</p>
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap gap-3 mt-6">
                <a href={waLink(sender.phone)} target="_blank" rel="noopener noreferrer" data-testid="contact-wa-btn">
                  <Button className="rounded-full bg-[#25D366] hover:brightness-110 text-white"><MessageCircle className="w-4 h-4 mr-2" /> Chat WhatsApp</Button>
                </a>
                <a href={GMAPS_SHARE} target="_blank" rel="noopener noreferrer" data-testid="contact-maps-btn">
                  <Button variant="outline" className="rounded-full border-[#00133F] text-[#00133F]"><ExternalLink className="w-4 h-4 mr-2" /> Buka di Google Maps</Button>
                </a>
              </div>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden border border-slate-200 bg-white min-h-[360px]" data-testid="contact-map">
            <iframe title="Lokasi Rooftop Print" src={mapEmbed} className="w-full h-full min-h-[360px]" style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
